import * as moment from "moment"
import { ModelAssumptionsUtil } from "src/app/core/v2/state/valuation-process/core/income/model-assumptions-util"
import { CostAssessmentRecordRow, DepreciatedRecordRow } from "../../types"
import { RecordOptions } from "./calculation"
import { normalizeRecords } from "./normalize"

export interface ThreeWaysAddUpOptions {
  kind: 'three-ways-add-up',
  physicalDepreciationFactor: number,
  functionalDepreciation: number,
  economicDepreciation: number
}
export function threeWaysAddUpMethod(
  records: CostAssessmentRecordRow[],
  recordOptions: RecordOptions,
  options: ThreeWaysAddUpOptions
) {
  const {
    physicalDepreciationFactor,
    functionalDepreciation,
    economicDepreciation
  } = options
  const {
    valuationDate,
    buildingConstructionDate,
    size
  } = recordOptions
  const _records = normalizeRecords(records, recordOptions)
  const _physicalDepreciationFactor = physicalDepreciationFactor / 100
  const _functionalDepreciation = functionalDepreciation / 100
  const _economicDepreciation = economicDepreciation / 100
  const _valuationDate = moment(valuationDate)
  const _buildingConstructionDate = moment(buildingConstructionDate)
  const yearDiff = ModelAssumptionsUtil._yearsDiff(
    _valuationDate,
    _buildingConstructionDate
  )

  const mappedRecords: DepreciatedRecordRow[] = _records.map(item => {
    const depreciatedCost = threeWaysAddUp(
      item.total_cost,
      _physicalDepreciationFactor,
      _functionalDepreciation,
      _economicDepreciation
    )
    return {
      ...item,
      depreciated_cost: depreciatedCost,
      depreciated_per_unit: size && size !== 0 ? depreciatedCost / size : 0
    }
  })

  const totalCost = mappedRecords.reduce(
    (acc, item) => {
      if (item.kind === 'header') return acc
      if (item.is_removed) return acc
      return acc + item.total_cost
    },
    0
  )

  const totalDepreciatedCost = mappedRecords.reduce(
    (acc, item) => {
      if (item.kind === 'header') return acc
      if (item.is_removed) return acc
      return acc + item.depreciated_cost
    },
    0
  )

  return {
    records: mappedRecords,
    graphValues: [],
    totalCost,
    totalDepreciatedCost,
    yearDiff
  }
}
export function threeWaysAddUp(
  totalCost: number,
  physicalDepreciationFactor: number,
  functionalDepreciation: number,
  economicDepreciation: number
) {
  const totalDepreciation = physicalDepreciationFactor + functionalDepreciation + economicDepreciation
  const factor = totalDepreciation >= 1 ? 1 : totalDepreciation
  return totalCost * (1 - factor)
}